// Tracks qué agentes están actualmente viendo cada conversación.
// Cada viewer tiene un timestamp `lastSeen` que se refresca con el heartbeat
// (cada 20s desde el frontend del viewer). Se limpia automáticamente
// si pasan >40s sin recibir noticia (cleanup en getter).

const STALE_THRESHOLD_MS = 40 * 1000;

const initialState = {
  byConversation: {}, // { [conversationId]: { [userId]: { user, lastSeen } } }
};

export const getters = {
  getViewers: $state => conversationId => {
    const byUser = $state.byConversation[conversationId] || {};
    const now = Date.now();
    return Object.values(byUser)
      .filter(entry => now - entry.lastSeen < STALE_THRESHOLD_MS)
      .map(entry => entry.user);
  },
};

export const actions = {
  add({ commit }, { conversationId, user, joinedAt = null }) {
    if (!conversationId || !user?.id) return;
    commit('UPSERT_VIEWER', {
      conversationId,
      user,
      lastSeen: Date.now(),
      joinedAt,
    });
  },
  remove({ commit }, { conversationId, userId }) {
    if (!conversationId || !userId) return;
    commit('REMOVE_VIEWER', { conversationId, userId });
  },
  prune({ commit, state: $state }) {
    const now = Date.now();
    Object.keys($state.byConversation).forEach(convId => {
      const users = $state.byConversation[convId] || {};
      Object.keys(users).forEach(userId => {
        if (now - users[userId].lastSeen >= STALE_THRESHOLD_MS) {
          commit('REMOVE_VIEWER', { conversationId: convId, userId });
        }
      });
    });
  },
};

export const mutations = {
  UPSERT_VIEWER($state, { conversationId, user, lastSeen, joinedAt = null }) {
    if (!$state.byConversation[conversationId]) $state.byConversation[conversationId] = {};
    // `since` = hora de entrada AUTORITATIVA del servidor (joinedAt en segundos),
    // igual para todos los clientes → "quién entró primero" es consistente.
    // Los heartbeats refrescan lastSeen pero NO mueven `since`. Fallback al
    // `since` previo o al lastSeen local solo por compatibilidad.
    const prev = $state.byConversation[conversationId][user.id];
    const since = (joinedAt ? joinedAt * 1000 : null) || prev?.since || lastSeen;
    $state.byConversation[conversationId] = {
      ...$state.byConversation[conversationId],
      [user.id]: { user, lastSeen, since },
    };
  },
  REMOVE_VIEWER($state, { conversationId, userId }) {
    const users = $state.byConversation[conversationId];
    if (!users) return;
    const { [userId]: _removed, ...rest } = users;
    $state.byConversation[conversationId] = rest;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
